import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ANavigationLink } from './';

export default function ANavigationLinkMultiList({ name, href, items }) {

	return (
		<li className="a-navigation-link a-navigation--drop-down-wrapper">
			<p className="nav-link white">
				<FormattedMessage id={name} defaultMessage="" />
			</p>
			<ul className="a-sub-navigation-multi-list">
				{
					items.map(item => <ANavigationLink key={item.name} name={item.name} href={item.href} />)
				}
			</ul>
		</li>
	);
}
ANavigationLinkMultiList.propTypes = {
	name: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.navigation-link-multi-list.js